module.exports = "<ng-content *ngIf=\" allow() \"></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/guard/guard.component.html
// module id = 1092
// module chunks = 0